const state = {
  activators: [],
};

const getters = {
  activators: state => state.activators,
};

const mutations = {
  setActivators(state, activators) {
    state.activators = activators;
  },
};

const actions = {
  activateUser({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/activations', params).then(response => {
      commit('user/set', response.data.user, { root: true });
      commit('purchaseReceipts/set', response.data.user.purchaseReceipts, { root: true });
      return response.data.activationResults;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
